"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.map");

var _classCallCheck = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/samlarsen-disney/Documents/DEVELOPMENT/sld.codes/sld-personal-site/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/createClass");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Absorbers = void 0;

var AbsorberInstance_1 = require("./AbsorberInstance");

var Utils_1 = require("../../Utils");

var Absorber_1 = require("./Options/Classes/Absorber");

var Enums_1 = require("./Enums");

var Absorbers =
/*#__PURE__*/
function () {
  function Absorbers(container) {
    _classCallCheck(this, Absorbers);

    this.container = container;
    this.array = [];
    this.absorbers = [];
    this.interactivityAbsorbers = [];
  }

  _createClass(Absorbers, [{
    key: "init",
    value: function init(options) {
      var _a, _b;

      if (!options) {
        return;
      }

      if (options.absorbers) {
        if (options.absorbers instanceof Array) {
          this.absorbers = options.absorbers.map(function (s) {
            var tmp = new Absorber_1.Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.absorbers instanceof Array) {
            this.absorbers = new Absorber_1.Absorber();
          }

          this.absorbers.load(options.absorbers);
        }
      }

      var interactivityAbsorbers = (_b = (_a = options.interactivity) === null || _a === void 0 ? void 0 : _a.modes) === null || _b === void 0 ? void 0 : _b.absorbers;

      if (interactivityAbsorbers) {
        if (interactivityAbsorbers instanceof Array) {
          this.interactivityAbsorbers = interactivityAbsorbers.map(function (s) {
            var tmp = new Absorber_1.Absorber();
            tmp.load(s);
            return tmp;
          });
        } else {
          if (this.interactivityAbsorbers instanceof Array) {
            this.interactivityAbsorbers = new Absorber_1.Absorber();
          }

          this.interactivityAbsorbers.load(interactivityAbsorbers);
        }
      }

      if (this.absorbers instanceof Array) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.absorbers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var absorberOptions = _step.value;
            var absorber = new AbsorberInstance_1.AbsorberInstance(this, this.container, absorberOptions);
            this.addAbsorber(absorber);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        var _absorberOptions = this.absorbers;

        var _absorber = new AbsorberInstance_1.AbsorberInstance(this, this.container, _absorberOptions);

        this.addAbsorber(_absorber);
      }
    }
  }, {
    key: "particleUpdate",
    value: function particleUpdate(particle) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.array[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var absorber = _step2.value;
          absorber.attract(particle);

          if (particle.destroyed) {
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: "draw",
    value: function draw(context) {
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.array[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var absorber = _step3.value;
          context.save();
          absorber.draw(context);
          context.restore();
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      this.array = [];
    }
  }, {
    key: "resize",
    value: function resize() {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.array[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var absorber = _step4.value;
          absorber.resize();
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  }, {
    key: "handleClickMode",
    value: function handleClickMode(mode) {
      var container = this.container;
      var absorberOptions = this.absorbers;
      var modeAbsorbers = this.interactivityAbsorbers;

      if (mode === Enums_1.AbsorberClickMode.absorber) {
        var absorbersModeOptions;

        if (modeAbsorbers instanceof Array) {
          if (modeAbsorbers.length > 0) {
            absorbersModeOptions = Utils_1.Utils.itemFromArray(modeAbsorbers);
          }
        } else {
          absorbersModeOptions = modeAbsorbers;
        }

        var absorbersOptions = absorbersModeOptions !== null && absorbersModeOptions !== void 0 ? absorbersModeOptions : absorberOptions instanceof Array ? Utils_1.Utils.itemFromArray(absorberOptions) : absorberOptions;
        var aPosition = container.interactivity.mouse.clickPosition;
        var absorber = new AbsorberInstance_1.AbsorberInstance(this, this.container, absorbersOptions, aPosition);
        this.addAbsorber(absorber);
      }
    }
  }, {
    key: "addAbsorber",
    value: function addAbsorber(absorber) {
      this.array.push(absorber);
    }
  }, {
    key: "removeAbsorber",
    value: function removeAbsorber(absorber) {
      var index = this.array.indexOf(absorber);

      if (index >= 0) {
        this.array.splice(index, 1);
      }
    }
  }]);

  return Absorbers;
}();

exports.Absorbers = Absorbers;